import { render } from "./ModalCreateCategory.vue?vue&type=template&id=5efc705a"
import script from "./ModalCreateCategory.vue?vue&type=script&lang=js"
export * from "./ModalCreateCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__